import { US_PATENT_PENDING_LABEL } from '@shared/patentPendingStamp.js';

export function PatentPendingStamp({
  className = '',
  label = US_PATENT_PENDING_LABEL,
}) {
  return (
    <span
      data-testid="patent-pending-stamp"
      className={`font-display text-xs font-bold uppercase tracking-[0.18em] text-stone-500 dark:text-stone-400 ${className}`.trim()}
    >
      {label}
    </span>
  );
}
